export default {"src":"/_next/static/media/crown.382d4987.svg","height":10,"width":12};